import { ButtonModule } from 'primeng/button';
import { EditorModule } from 'primeng/editor';
import { DropdownChangeEvent, DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ContentEditorComponent, EditorContent } from '../../../utility/content-editor/content-editor.component';
import { MessageService } from 'primeng/api';
import { AfterViewInit, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { activityOptions } from '../essay-pilot.component';
import { ActivityDetails } from '../../../models/account/extra-curricular/extraCurricularRequest';
import { PageResponse } from '../../../models/institute/randomInstituteResponse';
import { Activity } from '../../../models/account/extra-curricular/activity/activityResponse';
import { CompleteProfileService } from '../../../services/account/complete-profile.service';

@Component({
  selector: 'app-activity-editor',
  standalone: true,
  imports: [DropdownModule, ButtonModule, EditorModule, FormsModule, CommonModule, ContentEditorComponent],
  templateUrl: './activity-editor.component.html',
  styleUrl: './activity-editor.component.scss'
})
export class ActivityEditorComponent implements OnInit{
  constructor(private completeProfileService: CompleteProfileService,
    private cdr: ChangeDetectorRef, private messageService: MessageService
  ) { }
  
  ngOnInit(): void {
    this.initialContent = this.activity.htmlDescription ?? '';
  }

  //ExtraCurricular
  initialContent: string = '';
  isExtraCurricularSubmitted: boolean = false;
  isLoading: boolean = false;

  @Input() activity!: ActivityDetails;
  selectedExtracurricularOption: activityOptions | undefined;
  selectedExtracurricularActivity: ActivityDetails | undefined;
  activities: PageResponse<Activity> | undefined;


  resetEditorsContent() {
    const editor = document.querySelector('.ql-editor');
    if (editor) {
      // Overwrite the inner HTML of the editor
      editor.innerHTML = this.initialContent;
    }
  }

  onActivityDescriptionChange($event: EditorContent) {
    this.activity.textDescription = $event.textValue;
    this.activity.htmlDescription = $event.htmlValue;
    this.cdr.detectChanges(); 
  }

  get wordCount(): number {
    // this.getPendingComments();
    return this.activity?.textDescription
      ? this.activity.textDescription.trim().split(/\s+/).filter((word) => word).length
      : 0;
  }


  onActivitySubmit() {
    this.isExtraCurricularSubmitted = true; // Add a flag per activity if you want validation
  
    if (!this.activity.textDescription || this.activity.textDescription.trim().length === 0) {
      return;
    }
  
    this.isLoading = true;
    this.completeProfileService.updateExtraCurricularDescription({
      id: this.activity.id.toString(),
      textDescription: this.activity.textDescription,
      htmlDescription: this.activity.htmlDescription ?? ''
    }).subscribe({
      next: (response) => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: `Activity Description is updated!` });
        this.isLoading = false;
        this.isExtraCurricularSubmitted = false;
      },
      error: (err) => {
        console.warn(`Error updating activity: ${err}`);
        this.isLoading = false;
        this.isExtraCurricularSubmitted = false;
      }
    });
  }
}
